export enum BhsMembershipStatus {
  MEMBER = 'BHS Member',
  NON_MEMBER = 'Non BHS Member',
}
